import { Component } from '@verndale/core';
import MSScrollTriggeredAnimator from './ms-scroll-triggered-animator';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      el: this.el
    };

    this.animator = new MSScrollTriggeredAnimator(this.dom.el);
    this.animator.init();
  }
}

export default Module;
